import React, { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import { VerticalContext } from 'store/verticals/Context'
import Details from 'containers/VerticalPage/freelancers/Details/Details'
import Content from 'containers/VerticalPage/freelancers/Content/Content'
import { selectCurrentZone } from 'store/global'
import type { CurrentZone } from 'utils/types'
import VerticalDetailsContextProvider from 'store/verticalsDetails/Context'
import VerticalPageWrapper from 'containers/VerticalPage/common/VerticalPageWrapper/VerticalPageWrapper'
import { changeCurrentZoneIndexesFunc } from 'containers/VerticalPage/common/utils'
import { NetworkGraphButton } from 'components/network-graph/NetworkGraphButton'

const VerticalPage = (props: { changeCurrentZoneIndexes: changeCurrentZoneIndexesFunc }) => {
  const { verticalEntity } = useContext(VerticalContext)
  const currentZone: CurrentZone = useSelector(selectCurrentZone)

  useEffect(() => {
    props.changeCurrentZoneIndexes({
      baseIndices: currentZone?.gigIndices,
      activityIndices: currentZone?.gigActivityIndices,
    })
  }, [currentZone])

  return (
    <VerticalPageWrapper
      gridContainerSx={{
        gridTemplateColumns: '100%',
      }}
      breadcrumbs={
        <Breadcrumbs
          data={[
            { label: 'Home', href: '/' },
            { label: 'Freelancers', href: '/freelancers' },
            { label: verticalEntity?.entityDetails?.name || 'N/A' },
          ]}
        />
      }
      headerAction={<NetworkGraphButton />}
    >
      <Content />
      <VerticalDetailsContextProvider>
        <Details />
      </VerticalDetailsContextProvider>
    </VerticalPageWrapper>
  )
}

export default VerticalPage
